import React from "react";
import ServiceHeader from "./header";
import ServiceFooter from "./footer";

const AboutUs = () => {
  return (
    <>
      <ServiceHeader />

      <div className="mt-24 px-6 py-16 bg-gray-50">
        {/* Header Section */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-800">About Us</h1>
          <p className="mt-4 text-lg text-gray-600">
            Discover who we are and what we stand for.
          </p>
        </div>

        {/* Mission and Vision Section */}
        <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
          <div className="p-6 bg-white shadow-lg rounded-lg">
            <h2 className="text-2xl font-semibold text-gray-700 mb-4">Our Mission</h2>
            <p className="text-gray-600">
              Our mission is to deliver world-class services that empower our
              clients to achieve their goals. We are committed to innovation,
              quality, and building long-lasting relationships.
            </p>
          </div>
          <div className="p-6 bg-white shadow-lg rounded-lg">
            <h2 className="text-2xl font-semibold text-gray-700 mb-4">Our Vision</h2>
            <p className="text-gray-600">
              To be the most trusted and innovative service provider in the
              industry, creating value for our clients and communities through
              excellence and integrity.
            </p>
          </div>
        </div>

        {/* Core Values Section */}
        <div className="max-w-5xl mx-auto bg-white shadow-lg rounded-lg p-8 mb-12">
          <h2 className="text-2xl font-semibold text-gray-700 mb-4 text-center">
            Our Core Values
          </h2>
          <ul className="list-disc list-inside text-gray-600">
            <li>Customer-centric approach</li>
            <li>Integrity and transparency</li>
            <li>Innovation and excellence</li>
            <li>Teamwork and collaboration</li>
            <li>Commitment to sustainability</li>
          </ul>
        </div>

        {/* Services Overview Section */}
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {[
            { title: "Service 1", description: "Comprehensive solutions designed to meet your unique needs." },
            { title: "Service 2", description: "Cutting-edge technology to help you stay ahead of the competition." },
            { title: "Service 3", description: "Personalized support to ensure your success." },
          ].map((service, index) => (
            <div
              key={index}
              className="p-6 bg-white shadow-lg rounded-lg text-center"
            >
              <h3 className="text-xl font-semibold text-gray-700 mb-4">
                {service.title}
              </h3>
              <p className="text-gray-600">{service.description}</p>
            </div>
          ))}
        </div>

        {/* Call-to-Action Section */}
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-semibold text-gray-700 mb-6">
            Ready to experience the best services?
          </h2>
          <p className="text-gray-600 mb-8">
            Contact us today to learn more about how we can help you achieve your
            goals.
          </p>
          <button className="bg-[#111827] text-white px-6 py-3 rounded-lg shadow-md hover:bg-[#3C7C4E]">
            Get in Touch
          </button>
        </div>
      </div>

      <ServiceFooter />
    </>
  );
};

export default AboutUs;
